import React, { useEffect } from 'react';
import VisitUsSection from '../Common/VisitUsSection';
import BookVisitSection from '../Common/BookVisitSection';
import IntroSection from '../Common/IntroSection';
import AnimatedSection from '../Common/AnimatedSection';
import ServiceFeeOverview from './ServiceFeeOverview';
import { ServiceFeePackage } from './ServiceFeePackage';
import { ServiceFeeFactor } from './ServiceFeeFactor';
import { ServiceFeeFAQ } from './ServiceFeeFAQ';

function ServiceFee() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="about">
      <AnimatedSection id='intro' delay={200}>
        <IntroSection 
          title={"ABOUT PRISTINE SMILE"} 
          about={"Building lifetime relationships through positive experiences"} />
      </AnimatedSection>

      <AnimatedSection id='serviceFeeOverview' delay={400}>
        <ServiceFeeOverview />
      </AnimatedSection>

      <AnimatedSection id='serviceFeePackage' delay={400}>
        <ServiceFeePackage />
      </AnimatedSection>

      <AnimatedSection id='serviceFeeFactor' delay={400}>
        <ServiceFeeFactor />
      </AnimatedSection>

      <AnimatedSection id='serviceFeeFAQ' delay={400}>
        <ServiceFeeFAQ />
      </AnimatedSection>

      <AnimatedSection id='visitUs' delay={1000}>
        <VisitUsSection />
      </AnimatedSection>

      <AnimatedSection id='bookVisit' delay={1200}>
        <BookVisitSection />
      </AnimatedSection>
    </div>
  );
}

export default ServiceFee;